import * as React from 'react'
import { IReferral } from '@sales-center/common'
import { CustomerPreview, EmployeePreview, OtherPreview } from '.'
import { NotAddedReferralPreview } from './NotAddedReferralPreview'
import { PreviewVariants } from './typings'
import { NoReferralPreview } from './NoReferralPreview'

type Props = {
  billToCardMaxWidth?: string
  billToCardWidth?: string
  employeeListStatus: 'pending' | 'success' | 'fail'
  referral?: IReferral
  userListStatus: 'pending' | 'success' | 'fail'
  variant: PreviewVariants
  onButtonClick?: () => void
  mainVariant?: 'classic' | 'gray'
}

export function ReferralPreview(props: Props) {
  const {
    billToCardMaxWidth,
    billToCardWidth,
    employeeListStatus,
    referral,
    variant,
    mainVariant = 'classic',
  } = props

  if (!referral) return <NotAddedReferralPreview variant={mainVariant} />

  switch (referral.referralType) {
    case 'Customer':
      return (
        <CustomerPreview
          billToCardWidth={billToCardWidth}
          billToCardMaxWidth={billToCardMaxWidth}
          referral={referral}
          variant={variant}
        />
      )
    case 'Employee':
      return (
        <EmployeePreview
          employeeListStatus={employeeListStatus}
          referral={referral}
        />
      )
    case 'Other':
      return <OtherPreview referral={referral} />

    case 'None':
      return <NoReferralPreview referral={referral} />
    default:
      return <NotAddedReferralPreview />
  }
}
